import { gql } from "@apollo/client";

export interface ISendEmailToUsersRequiredForProjectInput {
  emails: string[];
  subject: string;
}

export interface ISendEmailToUsersRequiredForProjectResponse {
  id: string;
}

export interface IRankFinderCandidatesWithAIInput {
  skillsRequired: string[];
  skillsOptional?: string[];
  freeTexts: string[];
  candidateIds?: string[];
  limit?: number;
}

export interface IFinderCandidateRankItem {
  userId: string;
  score: number;
  rationale: string;
}

export interface IRankFinderCandidatesWithAIResponse {
  results: IFinderCandidateRankItem[];
}

export const SEND_EMAIL_WITH_USER_REQUIRED_BY_SKILLS = gql`
  mutation SendEmailToUsersRequiredForProject(
    $searchUsersRequiredForProjectInput: SearchUsersRequiredForProjectInput!
    $sendEmailToUsersRequiredForProjectInput: SendEmailToUsersRequiredForProjectInput!
  ) {
    sendEmailToUsersRequiredForProject(
      searchUsersRequiredForProjectInput: $searchUsersRequiredForProjectInput
      sendEmailToUsersRequiredForProjectInput: $sendEmailToUsersRequiredForProjectInput
    ) {
      id
      email
    }
  }
`;

export const RANK_FINDER_CANDIDATES_WITH_AI = gql`
  mutation RankFinderCandidatesWithAI(
    $rankFinderCandidatesWithAIInput: RankFinderCandidatesWithAIInput!
  ) {
    rankFinderCandidatesWithAI(
      rankFinderCandidatesWithAIInput: $rankFinderCandidatesWithAIInput
    ) {
      results {
        userId
        score
        rationale
      }
    }
  }
`;

export default {
  SEND_EMAIL_WITH_USER_REQUIRED_BY_SKILLS,
  RANK_FINDER_CANDIDATES_WITH_AI,
};
